/**
 * GA component summary that shows no deleted components.
 * This component needs to implement the wrapper ComponentTable.
 */
import React from 'react';
import {useSelector} from 'react-redux';
import {MotifIcon} from '@ey-xd/motif-react';
import {config as componentName} from '../../Common/ComponentTableV2/Columns/ComponentName';
import {config as formActionsColumn} from '../../Common/ComponentTableV2/Columns/FormActions';

import {IconoirTriangle, IconoirCheck} from '@ey-xd/motif-icon';
import {ICON_CIRCLE, ICON_TRIANGLE, ICON_CHECK} from '../../Common/ComponentTableV2/Columns/FormActions/utils/icons';
import {currentResource} from '../../../../../../../../../util/utils';
import {
	GAComponentTableColumns,
	GAGIFormActionColumns,
	extendedPagingOptions
} from '../../../../../../../../../util/uiconstants';
import ComponentTableV2 from '../../Common/ComponentTableV2';
import InvolvementSummaryFooter from '../InvolvementSummaryFooter';

export default function InvolvementSummary({components, formActions, isLoading}) {
	const scopes = useSelector(({groupAudit}) => groupAudit?.scopes);
	const getTableColumnConfiguration = (formActions) => {
		let otherColumnsCount = formActions?.availableActions
			.map((m) => m.customProperty1)
			.filter((e, i, self) => i === self.indexOf(e))?.length;
		// Default columns configuration
		const tableColumnsConfiguration = [componentName(currentResource.groupStructure, true)];

		const handleIcons = (item) => {
			// TODO: Refactor this to use a constant maybe !
			switch (item) {
				case ICON_CIRCLE:
					return <span className={item} />;
				case ICON_TRIANGLE:
					return <MotifIcon iconFunction={IconoirTriangle} size="16" />;
				case ICON_CHECK:
					return <MotifIcon className="check" iconFunction={IconoirCheck} size="24" />;
				default:
					return <span className="circle" />;
			}
		};

		/*TODO: Improve algorithm using a pre-existing config array
				and then excluding the columns that aren't returned from api */
		if (components?.length > 0 && formActions?.availableActions?.length > 0) {
			const columnsAvailable = [];

			formActions.availableActions.forEach((action) => {
				const typeOfColumn = parseInt(action.customProperty1);

				if (!columnsAvailable.includes(typeOfColumn)) {
					switch (typeOfColumn) {
						case GAGIFormActionColumns.Discussions.formActionValue:
							{
								tableColumnsConfiguration.push(
									formActionsColumn(
										currentResource.groupStructure.discussions,
										GAComponentTableColumns.discussions,
										formActions?.selectedActions,
										typeOfColumn,
										GAGIFormActionColumns.Discussions.orderValue,
										// TODO: Refactor this to use a constant maybe !
										handleIcons(ICON_CIRCLE),
										'minmax(var(--px-118), 1fr)'
									)
								);
							}
							break;
						case GAGIFormActionColumns.EDAP.formActionValue:
							{
								tableColumnsConfiguration.push(
									formActionsColumn(
										currentResource.groupStructure.EDAP,
										GAComponentTableColumns.EDAP,
										formActions?.selectedActions,
										typeOfColumn,
										GAGIFormActionColumns.EDAP.orderValue,
										// TODO: Refactor this to use a constant maybe !
										handleIcons(ICON_CIRCLE),
										'minmax(var(--px-87), 1fr)'
									)
								);
							}
							break;
						case GAGIFormActionColumns.SiteVisits.formActionValue:
							{
								tableColumnsConfiguration.push(
									formActionsColumn(
										currentResource.groupStructure.siteVisits,
										GAComponentTableColumns.siteVisits,
										formActions?.selectedActions,
										typeOfColumn,
										GAGIFormActionColumns.SiteVisits.orderValue,
										// TODO: Refactor this to use a constant maybe !
										handleIcons(ICON_CIRCLE),
										'minmax(var(--px-108), 1fr)'
									)
								);
							}
							break;
						case GAGIFormActionColumns.ReviewingWorkOfComponent.formActionValue:
							{
								tableColumnsConfiguration.push(
									formActionsColumn(
										currentResource.groupStructure.reviewWorkComponent,
										GAComponentTableColumns.reviewWorkComponent,
										formActions?.selectedActions,
										typeOfColumn,
										GAGIFormActionColumns.ReviewingWorkOfComponent.orderValue,
										// TODO: Refactor this to use a constant maybe !
										handleIcons(ICON_CIRCLE),
										'minmax(var(--px-195), 1fr)'
									)
								);
							}
							break;
						case GAGIFormActionColumns.Other.formActionValue:
							{
								tableColumnsConfiguration.push(
									formActionsColumn(
										currentResource.groupStructure.other,
										GAComponentTableColumns.other,
										formActions?.selectedActions,
										typeOfColumn,
										GAGIFormActionColumns.Other.orderValue,
										// TODO: Refactor this to use a constant maybe !
										handleIcons(ICON_CIRCLE),
										'minmax(var(--px-80), 1fr)'
									)
								);
							}
							break;
						case GAGIFormActionColumns.SignificantUpdates.formActionValue:
							{
								tableColumnsConfiguration.push(
									formActionsColumn(
										currentResource.groupStructure.significantUpdates,
										GAComponentTableColumns.significantUpdates,
										formActions?.selectedActions,
										typeOfColumn,
										GAGIFormActionColumns.SignificantUpdates.orderValue,
										// TODO: Refactor this to use a constant maybe !
										handleIcons(ICON_TRIANGLE),
										'minmax(var(--px-170), 1fr)'
									)
								);
							}
							break;
						case GAGIFormActionColumns.ExecutionComplete.formActionValue:
							{
								tableColumnsConfiguration.push(
									formActionsColumn(
										currentResource.groupStructure.executionComplete,
										GAComponentTableColumns.executionComplete,
										formActions?.selectedActions,
										typeOfColumn,
										GAGIFormActionColumns.ExecutionComplete.orderValue,
										// TODO: Refactor this to use a constant maybe !
										handleIcons(ICON_CHECK),
										'auto'
									)
								);
							}
							break;
						default:
							break;
					}

					columnsAvailable.push(typeOfColumn);
				}
			});
		}
		tableColumnsConfiguration.sort((a, b) => a.orderNumber - b.orderNumber);
		return tableColumnsConfiguration;
	};

	const renderComponentTable = () => {
		const props = {
			columnsConfig: getTableColumnConfiguration(formActions),
			labels: currentResource.groupStructure,
			data: components,
			defaultColumnSort: GAComponentTableColumns.name,
			pagination: true,
			paginationOptions: extendedPagingOptions.options,
			hideConfirmButton: true,
			infoPanel: () => <InvolvementSummaryFooter />
		};

		return <>{!isLoading && <ComponentTableV2 {...props} />}</>;
	};
	return renderComponentTable();
}

InvolvementSummary.propTypes = {};
InvolvementSummary.defaultProps = {};
